// ============================================================================
// Multi-Language Translations: English (en), Vietnamese (vi), Chinese (zh)
// ============================================================================

export const translations = {
  en: {
    // Header & Navigation
    'header.overview': 'Overview',
    'header.swap': 'Swap',
    'header.liquidity': 'Liquidity',
    'header.bridge': 'Bridge',
    'header.faucet': 'Faucet',
    'header.connectWallet': 'Connect Wallet',
    'header.connected': 'Connected',
    'header.walletAddress': 'Wallet Address',
    'header.copyAddress': 'Copy Address',
    'header.copied': 'Address copied to clipboard!',
    'header.disconnect': 'Disconnect',
    'header.selectNetwork': 'Select Network',
    'header.notConnected': 'Not Connected',
    'header.wrongNetwork': 'Wrong Network',
    'header.network': 'Network',
    'header.tagline': 'Multi-Chain DeFi Platform',
    'header.language': 'Language',

    // DApp Sub-header
    'dapp.live': 'Live',
    'dapp.fast': '<1s Fast',

    // Common
    'common.loading': 'Loading...',
    'common.close': 'Close',
    'common.max': 'MAX',
    'common.balance': 'Balance',
    'common.rate': 'Rate',
    'common.switchNetwork': 'Switch Network',
    'common.connectWallet': 'Connect Wallet',

    // Swap
    'swap.title': 'Swap',
    'swap.bestRate': 'Best Rate',
    'swap.slippage': 'Slippage',
    'swap.youPay': 'You Pay',
    'swap.youReceive': 'You Receive',
    'swap.est': 'Est.',
    'swap.minReceived': 'Minimum Received',
    'swap.slippageTol': 'Slippage Tolerance',
    'swap.networkFee': 'Network Fee',
    'swap.enterAmount': 'Enter an amount',
    'swap.insufficientBalance': 'Insufficient {symbol} Balance',
    'swap.swapping': 'Swapping...',
    'swap.action': 'Swap',
    'swap.connectWallet': 'Connect Wallet',
    'swap.selectPayToken': 'Select Token to Pay',
    'swap.selectReceiveToken': 'Select Token to Receive',
    'swap.searchPlaceholder': 'Search tokens by name or symbol...',
    'swap.noTokens': 'No tokens found matching',
    'swap.switchTokens': 'Switch Tokens',
    'swap.swapSuccess': 'Swap executed successfully!',
    'swap.swapFailed': 'Swap failed: {error}',
    'swap.route': 'Routing Path',
    'swap.priceImpact': 'Price Impact',
    'swap.lpFee': 'Liquidity Fee (0.25%)',
    'swap.txSubmitted': 'Transaction Submitted',
    'swap.estimatedNotice': 'Market Oracle Estimated Rate',

    // Liquidity
    'liquidity.addLiquidity': 'Add Liquidity',
    'liquidity.removeLiquidity': 'Remove Liquidity',
    'liquidity.tokenA': 'Token A',
    'liquidity.tokenB': 'Token B',
    'liquidity.selectTokenA': 'Select Token A',
    'liquidity.selectTokenB': 'Select Token B',
    'liquidity.poolInfo': 'Pool Information',
    'liquidity.poolExists': 'Pool exists',
    'liquidity.yes': 'Yes',
    'liquidity.reserve': 'Reserve',
    'liquidity.adding': 'Adding Liquidity...',
    'liquidity.removing': 'Removing Liquidity...',
    'liquidity.noPool': 'No liquidity pool exists for this pair.',
    'liquidity.lpToRemove': 'LP Tokens to Remove',
    'liquidity.available': 'Available',
    'liquidity.yourLpBalance': 'Your LP Balance',
    'liquidity.successAdd': 'Liquidity added successfully!',
    'liquidity.successRemove': 'Liquidity removed successfully!',
    'liquidity.addFailed': 'Add liquidity failed',
    'liquidity.removeFailed': 'Remove liquidity failed',

    // Crosschain Bridge
    'bridge.title': 'Cross-Chain Bridge',
    'bridge.subtitle': 'Transfer tokens seamlessly across different blockchain networks',
    'bridge.from': 'From',
    'bridge.to': 'To',
    'bridge.sourceChain': 'Source Chain',
    'bridge.destChain': 'Destination Chain',
    'bridge.selectSourceChain': 'Select Source Chain',
    'bridge.selectDestChain': 'Select Destination Chain',
    'bridge.selectToken': 'Select Token',
    'bridge.amountToBridge': 'Amount to Bridge',
    'bridge.estimatedTime': 'Estimated Time',
    'bridge.bridgeFee': 'Bridge Fee',
    'bridge.transferAmount': 'Transfer Amount',
    'bridge.youWillReceive': 'You will receive',
    'bridge.youllReceive': "You'll Receive",
    'bridge.bridgeAction': 'Bridge Tokens',
    'bridge.bridging': 'Bridging...',
    'bridge.protocol': 'Bridge Protocol',
    'bridge.recentTransactions': 'Recent Transactions',
    'bridge.volume24h': '24h Volume',
    'bridge.selectChain': 'Select Chain',
    'bridge.stats': 'Bridge Statistics',
    'bridge.success': 'Bridge transaction initiated successfully!',
    'bridge.bridgeFailed': 'Bridge transfer failed: {error}',

    // Faucet
    'faucet.title': 'Token Faucet',
    'faucet.subtitle': 'Get free test tokens for development and testing on supported networks',
    'faucet.loading': 'Loading faucet information...',
    'faucet.yourAddress': 'Your Wallet Address',
    'faucet.freeTokens': 'Get Free Test Tokens',
    'faucet.desc': 'Click the button below to visit the official faucet and get free test tokens for development.',
    'faucet.claim': 'Get {amount} {token}',
    'faucet.altFaucets': 'Alternative Faucets',
    'faucet.instructions': 'Instructions',
    'faucet.connectPrompt': 'Connect your wallet to check balance',
    'faucet.disconnected': 'Disconnected',
    'faucet.purchaseTokens': 'Purchase Tokens',
    'faucet.mainnetNotice': 'This is a mainnet network. You need to purchase {token} from a cryptocurrency exchange to use this network.',
    'faucet.networkInfo': 'Network Information',
    'faucet.viewExplorer': 'View on Explorer',
    'faucet.option': 'Option {num}',
    'faucet.chainId': 'Chain ID:',
    'faucet.nativeToken': 'Native Token:',
    'faucet.explorer': 'Explorer:',
    'faucet.instantClaim': 'Instant Testnet Faucet',
    'faucet.instantClaimDesc': 'Claim 50 HUC testnet tokens directly to your connected wallet for testing',
    'faucet.claimButton': 'Claim 50 HUC Free',
    'faucet.claiming': 'Minting test tokens...',
    'faucet.claimedSuccess': 'Successfully minted 50 HUC testnet tokens to your wallet!',
    'faucet.cooldown': 'Cooldown active. You can claim once per 24 hours.',
    'network.mainnet': 'Mainnet',

    // Overview / Landing Page
    'hero.badge': 'Next-Gen DeFi Platform',
    'hero.titleMain': 'HuanChain DEX',
    'hero.titleSub': 'Professional Trading Platform',
    'hero.desc': 'Experience the future of decentralized finance with lightning-fast trades, deep liquidity pools, and seamless cross-chain bridging on {network}.',
    'hero.launchApp': 'Launch App',
    'hero.connectWallet': 'Connect Wallet',
    'hero.exploreLiquidity': 'Explore Liquidity',
    'hero.audited': 'Audited Smart Contracts • High Speed • Minimal Fees',
    'stats.volume': 'Total Volume Traded',
    'stats.users': 'Active Users',
    'stats.tokens': 'Listed Tokens',
    'stats.liquidity': 'Total Liquidity',
    'features.title': 'Why Choose HuanChain DEX?',
    'features.subtitle': 'Cutting-edge DeFi technology with institutional-grade security',
    'features.f1Title': 'Lightning Fast Trades',
    'features.f1Desc': 'Execute trades in milliseconds with our optimized smart contracts. Experience near-zero slippage and minimal gas fees.',
    'features.f2Title': 'Deep Liquidity Pools',
    'features.f2Desc': 'Earn high yields by providing liquidity to our pools with automatic reward compounding and impermanent loss mitigation.',
    'features.f3Title': 'Cross-Chain Bridge',
    'features.f3Desc': 'Seamlessly transfer assets across 10+ blockchains with our secure, audited bridge infrastructure.',
    'features.f4Title': 'Bank-Grade Security',
    'features.f4Desc': 'Audited contracts, real-time monitoring, and multi-sig security ensure your funds are always safe.',
    'features.f5Title': 'Advanced Analytics',
    'features.f5Desc': 'Real-time charts, technical indicators, and portfolio tracking for smart decision making.',
    'features.f6Title': 'Yield Farming',
    'features.f6Desc': 'Maximize your returns with staking and yield strategies tailored for crypto holders.',
    'features.b1_1': 'Sub-second execution',
    'features.b1_2': '99.9% uptime',
    'features.b1_3': 'MEV protection',
    'features.b2_1': 'High APR',
    'features.b2_2': 'Auto-compounding',
    'features.b2_3': 'Capital efficiency',
    'features.b3_1': '10+ supported chains',
    'features.b3_2': '$500M+ bridged',
    'features.b3_3': 'Fast transfers',
    'features.b4_1': 'Multi-sig protection',
    'features.b4_2': 'Audited by top firms',
    'features.b4_3': 'Non-custodial',
    'features.b5_1': 'Real-time data',
    'features.b5_2': 'High accuracy',
    'features.b5_3': 'Portfolio insights',
    'features.b6_1': 'Auto-compound yields',
    'features.b6_2': 'Risk-adjusted returns',
    'features.b6_3': 'Flexible rewards',
    'contract.info': 'Contract Information',
    'contract.switchTo': 'Switch to {network}',
    'contract.router': 'Router:',
    'contract.factory': 'Factory:',
    'app.installMetaMask': 'Please install MetaMask or another Web3 wallet to connect!',
    'steps.title': 'Get Started in Minutes',
    'steps.subtitle': 'Join thousands of traders who trust HuanChain DEX for their DeFi needs',
    'steps.s1Title': 'Connect Your Wallet',
    'steps.s1Desc': 'Use MetaMask or 20+ supported Web3 wallets to get started instantly.',
    'steps.s2Title': 'Get Tokens',
    'steps.s2Desc': 'Get testnet tokens from our faucet or transfer funds to your wallet to start trading.',
    'steps.s3Title': 'Start Trading',
    'steps.s3Desc': 'Swap tokens, provide liquidity, or bridge assets across chains with just a few clicks.',
    'trusted.title': 'Trusted by Leading Projects',
    'cta.title': 'Ready to Experience the Future of DeFi?',
    'cta.desc': 'Join over 150,000 traders who choose HuanChain DEX for their decentralized trading needs.',

    // Footer
    'footer.desc': 'The leading decentralized exchange on HuanChain. Trade, earn, and build on the most efficient DeFi platform.',
    'footer.protocol': 'Protocol',
    'footer.resources': 'Resources',
    'footer.ecosystem': 'Ecosystem',
    'footer.legal': 'Legal',
    'footer.community': 'Community',
    'footer.docs': 'Documentation',
    'footer.bounty': 'Bug Bounty',
    'footer.governance': 'Governance',
    'footer.forum': 'Forum',
    'footer.analytics': 'Analytics',
    'footer.tokenLists': 'Token Lists',
    'footer.brandAssets': 'Brand Assets',
    'footer.careers': 'Careers',
    'footer.terms': 'Terms of Service',
    'footer.privacy': 'Privacy Policy',
    'footer.cookie': 'Cookie Policy',
    'footer.disclaimerTitle': 'Disclaimer',
    'footer.disclaimer': 'HuanChain DEX is a decentralized protocol. Cryptocurrency trading involves substantial risk of loss. Always do your own research before trading.',
    'footer.securityNotice': 'Security Notice',
    'footer.securityDesc': 'Always verify contract addresses and never share your private keys. HuanChain will never ask for your seed phrase.',
    'footer.allRightsReserved': 'All rights reserved.',
    'footer.riskWarning': 'Use at your own risk. This is experimental software.'
  },

  vi: {
    // Header & Navigation
    'header.overview': 'Tổng quan',
    'header.swap': 'Giao dịch',
    'header.liquidity': 'Thanh khoản',
    'header.bridge': 'Cầu nối',
    'header.faucet': 'Vòi Token',
    'header.connectWallet': 'Kết nối ví',
    'header.connected': 'Đã kết nối',
    'header.walletAddress': 'Địa chỉ ví',
    'header.copyAddress': 'Sao chép địa chỉ',
    'header.copied': 'Đã sao chép địa chỉ ví!',
    'header.disconnect': 'Ngắt kết nối',
    'header.selectNetwork': 'Chọn mạng lưới',
    'header.notConnected': 'Chưa kết nối',
    'header.wrongNetwork': 'Sai mạng',
    'header.network': 'Mạng lưới',
    'header.tagline': 'Nền tảng DeFi Đa Chuỗi',
    'header.language': 'Ngôn ngữ',

    // DApp Sub-header
    'dapp.live': 'Hoạt động',
    'dapp.fast': '<1s Siêu tốc',

    // Common
    'common.loading': 'Đang tải...',
    'common.close': 'Đóng',
    'common.max': 'TỐI ĐA',
    'common.balance': 'Số dư',
    'common.rate': 'Tỷ giá',
    'common.switchNetwork': 'Chuyển mạng',
    'common.connectWallet': 'Kết nối ví',

    // Swap
    'swap.title': 'Giao dịch Token',
    'swap.bestRate': 'Tỷ giá tốt nhất',
    'swap.slippage': 'Độ trượt giá',
    'swap.youPay': 'Bạn trả',
    'swap.youReceive': 'Bạn nhận',
    'swap.est': 'Ước tính',
    'swap.minReceived': 'Nhận tối thiểu',
    'swap.slippageTol': 'Dung sai trượt giá',
    'swap.networkFee': 'Phí mạng ước tính',
    'swap.enterAmount': 'Nhập số lượng',
    'swap.insufficientBalance': 'Số dư {symbol} không đủ',
    'swap.swapping': 'Đang giao dịch...',
    'swap.action': 'Đổi ngay',
    'swap.connectWallet': 'Kết nối ví',
    'swap.selectPayToken': 'Chọn Token thanh toán',
    'swap.selectReceiveToken': 'Chọn Token muốn nhận',
    'swap.searchPlaceholder': 'Tìm token theo tên hoặc ký hiệu...',
    'swap.noTokens': 'Không tìm thấy token khớp với',
    'swap.switchTokens': 'Đảo chiều token',
    'swap.swapSuccess': 'Giao dịch hoán đổi thành công!',
    'swap.swapFailed': 'Giao dịch thất bại: {error}',
    'swap.route': 'Tuyến đường hoán đổi',
    'swap.priceImpact': 'Tác động giá',
    'swap.lpFee': 'Phí thanh khoản (0.25%)',
    'swap.txSubmitted': 'Giao dịch đã được gửi',
    'swap.estimatedNotice': 'Tỷ giá ước tính từ Oracle thị trường',

    // Liquidity
    'liquidity.addLiquidity': 'Thêm thanh khoản',
    'liquidity.removeLiquidity': 'Rút thanh khoản',
    'liquidity.tokenA': 'Token A',
    'liquidity.tokenB': 'Token B',
    'liquidity.selectTokenA': 'Chọn Token A',
    'liquidity.selectTokenB': 'Chọn Token B',
    'liquidity.poolInfo': 'Thông tin bể thanh khoản',
    'liquidity.poolExists': 'Bể thanh khoản',
    'liquidity.yes': 'Đã tồn tại',
    'liquidity.reserve': 'Dự trữ',
    'liquidity.adding': 'Đang thêm thanh khoản...',
    'liquidity.removing': 'Đang rút thanh khoản...',
    'liquidity.noPool': 'Chưa có bể thanh khoản cho cặp token này.',
    'liquidity.lpToRemove': 'Số lượng LP muốn rút',
    'liquidity.available': 'Khả dụng',
    'liquidity.yourLpBalance': 'Số dư LP của bạn',
    'liquidity.successAdd': 'Thêm thanh khoản thành công!',
    'liquidity.successRemove': 'Rút thanh khoản thành công!',
    'liquidity.addFailed': 'Thêm thanh khoản thất bại',
    'liquidity.removeFailed': 'Rút thanh khoản thất bại',

    // Crosschain Bridge
    'bridge.title': 'Cầu nối Đa Chuỗi',
    'bridge.subtitle': 'Chuyển token mượt mà giữa các mạng blockchain khác nhau',
    'bridge.from': 'Từ chuỗi',
    'bridge.to': 'Đến chuỗi',
    'bridge.sourceChain': 'Chuỗi nguồn',
    'bridge.destChain': 'Chuỗi đích',
    'bridge.selectSourceChain': 'Chọn chuỗi nguồn',
    'bridge.selectDestChain': 'Chọn chuỗi đích',
    'bridge.selectToken': 'Chọn Token',
    'bridge.amountToBridge': 'Số lượng cần chuyển',
    'bridge.estimatedTime': 'Thời gian ước tính',
    'bridge.bridgeFee': 'Phí cầu nối',
    'bridge.transferAmount': 'Số lượng chuyển',
    'bridge.youWillReceive': 'Bạn sẽ nhận được',
    'bridge.youllReceive': 'Bạn sẽ nhận được',
    'bridge.bridgeAction': 'Chuyển chuỗi ngay',
    'bridge.bridging': 'Đang chuyển chuỗi...',
    'bridge.protocol': 'Giao thức cầu nối',
    'bridge.recentTransactions': 'Giao dịch gần đây',
    'bridge.volume24h': 'Khối lượng 24h',
    'bridge.selectChain': 'Chọn mạng chuỗi',
    'bridge.stats': 'Thống kê cầu nối',
    'bridge.success': 'Giao dịch chuyển chuỗi đã được khởi tạo!',
    'bridge.bridgeFailed': 'Giao dịch cầu nối thất bại: {error}',

    // Faucet
    'faucet.title': 'Vòi cấp Token Testnet',
    'faucet.subtitle': 'Nhận token thử nghiệm miễn phí để phát triển và kiểm thử trên các mạng được hỗ trợ',
    'faucet.loading': 'Đang tải thông tin vòi testnet...',
    'faucet.yourAddress': 'Địa chỉ ví của bạn',
    'faucet.freeTokens': 'Nhận Token Testnet Miễn Phí',
    'faucet.desc': 'Bấm nút bên dưới để truy cập vòi chính thức và nhận token testnet miễn phí.',
    'faucet.claim': 'Nhận {amount} {token}',
    'faucet.altFaucets': 'Vòi Testnet dự phòng',
    'faucet.instructions': 'Hướng dẫn nhận',
    'faucet.connectPrompt': 'Kết nối ví để kiểm tra số dư',
    'faucet.disconnected': 'Chưa kết nối',
    'faucet.purchaseTokens': 'Mua Token',
    'faucet.mainnetNotice': 'Đây là mạng chính thức (Mainnet). Bạn cần mua {token} từ sàn giao dịch tiền mã hóa để sử dụng mạng này.',
    'faucet.networkInfo': 'Thông tin mạng lưới',
    'faucet.viewExplorer': 'Xem trên Explorer',
    'faucet.option': 'Kênh dự phòng {num}',
    'faucet.chainId': 'Mã chuỗi (Chain ID):',
    'faucet.nativeToken': 'Token gốc:',
    'faucet.explorer': 'Trình khám phá:',
    'faucet.instantClaim': 'Vòi cấp Token tức thì trong DApp',
    'faucet.instantClaimDesc': 'Nhận trực tiếp 50 HUC testnet vào ví đang kết nối để trải nghiệm sàn DEX',
    'faucet.claimButton': 'Nhận ngay 50 HUC',
    'faucet.claiming': 'Đang đúc token testnet...',
    'faucet.claimedSuccess': 'Đã nhận thành công 50 HUC testnet vào ví của bạn!',
    'faucet.cooldown': 'Bạn đã nhận gần đây. Vui lòng quay lại sau 24 giờ.',
    'network.mainnet': 'Mạng chính (Mainnet)',

    // Overview / Landing Page
    'hero.badge': 'Nền tảng DeFi Thế hệ mới',
    'hero.titleMain': 'HuanChain DEX',
    'hero.titleSub': 'Sàn Giao Dịch Chuyên Nghiệp',
    'hero.desc': 'Trải nghiệm tương lai của tài chính phi tập trung với tốc độ siêu nhanh, bể thanh khoản sâu và cầu nối đa chuỗi mượt mà trên {network}.',
    'hero.launchApp': 'Mở ứng dụng',
    'hero.connectWallet': 'Kết nối ví',
    'hero.exploreLiquidity': 'Khám phá thanh khoản',
    'hero.audited': 'Hợp đồng thông minh đã kiểm toán • Tốc độ cao • Phí cực thấp',
    'stats.volume': 'Tổng khối lượng giao dịch',
    'stats.users': 'Người dùng hoạt động',
    'stats.tokens': 'Token đã niêm yết',
    'stats.liquidity': 'Tổng thanh khoản (TVL)',
    'features.title': 'Tại sao chọn HuanChain DEX?',
    'features.subtitle': 'Công nghệ DeFi tiên tiến với độ bảo mật cấp tổ chức tài chính',
    'features.f1Title': 'Khớp lệnh thần tốc',
    'features.f1Desc': 'Khớp lệnh trong tích tắc với hợp đồng thông minh tối ưu. Độ trượt giá gần như bằng 0 và phí gas tối thiểu.',
    'features.f2Title': 'Bể thanh khoản sâu',
    'features.f2Desc': 'Lợi nhuận hấp dẫn khi cung cấp thanh khoản với cơ chế tự động tái đầu tư và hạn chế tổn thất tạm thời.',
    'features.f3Title': 'Cầu nối đa chuỗi',
    'features.f3Desc': 'Chuyển đổi tài sản liền mạch giữa hơn 10 blockchain với hạ tầng bảo mật được kiểm toán chặt chẽ.',
    'features.f4Title': 'Bảo mật chuẩn ngân hàng',
    'features.f4Desc': 'Hợp đồng kiểm toán độc lập, giám sát thời gian thực và chữ ký đa bên đảm bảo tài sản luôn an toàn.',
    'features.f5Title': 'Phân tích chuyên sâu',
    'features.f5Desc': 'Biểu đồ trực tiếp, chỉ báo kỹ thuật và quản lý danh mục giúp đưa ra quyết định giao dịch thông minh.',
    'features.f6Title': 'Canh tác lợi nhuận (Farming)',
    'features.f6Desc': 'Tối đa hóa lợi nhuận với các chiến lược staking và yield farming được thiết kế tối ưu.',
    'features.b1_1': 'Khớp lệnh dưới 1 giây',
    'features.b1_2': 'Thời gian hoạt động 99.9%',
    'features.b1_3': 'Bảo vệ chống MEV',
    'features.b2_1': 'Lợi suất APR hấp dẫn',
    'features.b2_2': 'Tự động tái đầu tư',
    'features.b2_3': 'Hiệu quả sử dụng vốn',
    'features.b3_1': 'Hỗ trợ 10+ mạng chuỗi',
    'features.b3_2': 'Hơn $500M đã chuyển',
    'features.b3_3': 'Xử lý tốc độ cao',
    'features.b4_1': 'Bảo vệ bằng chữ ký đa bên',
    'features.b4_2': 'Kiểm toán bởi các hãng hàng đầu',
    'features.b4_3': 'Phi tập trung - Không lưu ký',
    'features.b5_1': 'Dữ liệu thời gian thực',
    'features.b5_2': 'Độ chính xác cao',
    'features.b5_3': 'Phân tích danh mục thông minh',
    'features.b6_1': 'Tự động tích lũy lãi suất kép',
    'features.b6_2': 'Lợi nhuận tối ưu theo rủi ro',
    'features.b6_3': 'Phần thưởng linh hoạt',
    'contract.info': 'Thông tin hợp đồng',
    'contract.switchTo': 'Chuyển sang {network}',
    'contract.router': 'Bộ định tuyến (Router):',
    'contract.factory': 'Nhà máy (Factory):',
    'app.installMetaMask': 'Vui lòng cài đặt MetaMask hoặc ví Web3 để kết nối!',
    'steps.title': 'Bắt đầu chỉ trong vài phút',
    'steps.subtitle': 'Gia nhập cùng hàng nghìn nhà giao dịch tin tưởng lựa chọn HuanChain DEX',
    'steps.s1Title': 'Kết nối ví của bạn',
    'steps.s1Desc': 'Sử dụng MetaMask hoặc hơn 20 ví Web3 được hỗ trợ để bắt đầu ngay tức thì.',
    'steps.s2Title': 'Nhận Token',
    'steps.s2Desc': 'Lấy token testnet từ vòi hoặc nạp tiền vào ví để sẵn sàng thực hiện giao dịch.',
    'steps.s3Title': 'Bắt đầu giao dịch',
    'steps.s3Desc': 'Đổi token, thêm thanh khoản hoặc chuyển chuỗi tài sản chỉ với vài thao tác đơn giản.',
    'trusted.title': 'Được tin tưởng bởi các dự án hàng đầu',
    'cta.title': 'Sẵn sàng trải nghiệm tương lai của DeFi?',
    'cta.desc': 'Gia nhập hơn 150.000 nhà giao dịch tin dùng HuanChain DEX cho mọi nhu cầu tài chính phi tập trung.',

    // Footer
    'footer.desc': 'Sàn giao dịch phi tập trung hàng đầu trên HuanChain. Giao dịch, sinh lời và phát triển trên nền tảng DeFi hiệu quả nhất.',
    'footer.protocol': 'Giao thức',
    'footer.resources': 'Tài nguyên',
    'footer.ecosystem': 'Hệ sinh thái',
    'footer.legal': 'Pháp lý',
    'footer.community': 'Cộng đồng',
    'footer.docs': 'Tài liệu hướng dẫn',
    'footer.bounty': 'Săn lỗi nhận thưởng',
    'footer.governance': 'Quản trị cộng đồng',
    'footer.forum': 'Diễn đàn thảo luận',
    'footer.analytics': 'Dữ liệu phân tích',
    'footer.tokenLists': 'Danh sách Token',
    'footer.brandAssets': 'Tài nguyên thương hiệu',
    'footer.careers': 'Cơ hội việc làm',
    'footer.terms': 'Điều khoản dịch vụ',
    'footer.privacy': 'Chính sách bảo mật',
    'footer.cookie': 'Chính sách Cookie',
    'footer.disclaimerTitle': 'Tuyên bố miễn trừ',
    'footer.disclaimer': 'HuanChain DEX là một giao thức phi tập trung. Giao dịch tiền mã hóa tiềm ẩn rủi ro thua lỗ tài chính. Hãy luôn tự nghiên cứu kỹ lưỡng trước khi giao dịch.',
    'footer.securityNotice': 'Lưu ý bảo mật',
    'footer.securityDesc': 'Luôn kiểm tra kỹ địa chỉ hợp đồng và tuyệt đối không chia sẻ khóa cá nhân (private key). HuanChain sẽ không bao giờ hỏi cụm từ khôi phục của bạn.',
    'footer.allRightsReserved': 'Bảo lưu mọi quyền.',
    'footer.riskWarning': 'Sử dụng tự chịu rủi ro. Đây là phiên bản thử nghiệm.'
  },

  zh: {
    // Header & Navigation
    'header.overview': '概览',
    'header.swap': '兑换',
    'header.liquidity': '流动性',
    'header.bridge': '跨链桥',
    'header.faucet': '水龙头',
    'header.connectWallet': '连接钱包',
    'header.connected': '已连接',
    'header.walletAddress': '钱包地址',
    'header.copyAddress': '复制地址',
    'header.copied': '地址已成功复制到剪贴板！',
    'header.disconnect': '断开连接',
    'header.selectNetwork': '选择网络',
    'header.notConnected': '未连接',
    'header.wrongNetwork': '网络错误',
    'header.network': '网络',
    'header.tagline': '多链DeFi去中心化交易平台',
    'header.language': '语言',

    // DApp Sub-header
    'dapp.live': '在线',
    'dapp.fast': '<1秒 极速',

    // Common
    'common.loading': '加载中...',
    'common.close': '关闭',
    'common.max': '最大',
    'common.balance': '余额',
    'common.rate': '汇率',
    'common.switchNetwork': '切换网络',
    'common.connectWallet': '连接钱包',

    // Swap
    'swap.title': '代币兑换',
    'swap.bestRate': '最优汇率',
    'swap.slippage': '滑点设置',
    'swap.youPay': '支付代币',
    'swap.youReceive': '获得代币',
    'swap.est': '预估',
    'swap.minReceived': '最少获得',
    'swap.slippageTol': '滑点容差',
    'swap.networkFee': '网络预估费用',
    'swap.enterAmount': '输入兑换金额',
    'swap.insufficientBalance': '{symbol} 余额不足',
    'swap.swapping': '正在兑换...',
    'swap.action': '立即兑换',
    'swap.connectWallet': '连接钱包',
    'swap.selectPayToken': '选择支付代币',
    'swap.selectReceiveToken': '选择接收代币',
    'swap.searchPlaceholder': '按代币名称或符号搜索...',
    'swap.noTokens': '未找到匹配的代币',
    'swap.switchTokens': '对调代币',
    'swap.swapSuccess': '代币兑换成功！',
    'swap.swapFailed': '兑换失败：{error}',
    'swap.route': '路由路径',
    'swap.priceImpact': '价格影响',
    'swap.lpFee': '流动性费用 (0.25%)',
    'swap.txSubmitted': '交易已提交',
    'swap.estimatedNotice': '预言机市场估算汇率',

    // Liquidity
    'liquidity.addLiquidity': '添加流动性',
    'liquidity.removeLiquidity': '移除流动性',
    'liquidity.tokenA': '代币 A',
    'liquidity.tokenB': '代币 B',
    'liquidity.selectTokenA': '选择代币 A',
    'liquidity.selectTokenB': '选择代币 B',
    'liquidity.poolInfo': '流动性池信息',
    'liquidity.poolExists': '资金池状态',
    'liquidity.yes': '已存在',
    'liquidity.reserve': '资金储备',
    'liquidity.adding': '正在添加流动性...',
    'liquidity.removing': '正在移除流动性...',
    'liquidity.noPool': '该交易对暂无流动性池。',
    'liquidity.lpToRemove': '要移除的LP代币数量',
    'liquidity.available': '可用',
    'liquidity.yourLpBalance': '您的LP代币余额',
    'liquidity.successAdd': '流动性添加成功！',
    'liquidity.successRemove': '流动性移除成功！',
    'liquidity.addFailed': '添加流动性失败',
    'liquidity.removeFailed': '移除流动性失败',

    // Crosschain Bridge
    'bridge.title': '多链跨链桥',
    'bridge.subtitle': '在不同的区块链网络之间快速安全地转移资产',
    'bridge.from': '来源链',
    'bridge.to': '目标链',
    'bridge.sourceChain': '来源链',
    'bridge.destChain': '目标链',
    'bridge.selectSourceChain': '选择来源链',
    'bridge.selectDestChain': '选择目标链',
    'bridge.selectToken': '选择代币',
    'bridge.amountToBridge': '跨链划转数量',
    'bridge.estimatedTime': '预计到账时间',
    'bridge.bridgeFee': '跨链手续费',
    'bridge.transferAmount': '划转数量',
    'bridge.youWillReceive': '预计收到',
    'bridge.youllReceive': '预计收到',
    'bridge.bridgeAction': '开始跨链',
    'bridge.bridging': '跨链中...',
    'bridge.protocol': '跨链协议',
    'bridge.recentTransactions': '近期交易记录',
    'bridge.volume24h': '24小时成交量',
    'bridge.selectChain': '选择区块链网络',
    'bridge.stats': '跨链统计',
    'bridge.success': '跨链交易已成功提交发起！',
    'bridge.bridgeFailed': '跨链转账失败：{error}',

    // Faucet
    'faucet.title': '测试代币水龙头',
    'faucet.subtitle': '在支持的测试网络上免费获取测试代币，用于开发与测试体验',
    'faucet.loading': '正在加载水龙头信息...',
    'faucet.yourAddress': '您的钱包地址',
    'faucet.freeTokens': '免费领取测试代币',
    'faucet.desc': '点击下方按钮前往官方水龙头，轻松领取测试网络代币。',
    'faucet.claim': '领取 {amount} {token}',
    'faucet.altFaucets': '备用水龙头渠道',
    'faucet.instructions': '领取指南与步骤',
    'faucet.connectPrompt': '请先连接钱包以查看代币余额',
    'faucet.disconnected': '未连接',
    'faucet.purchaseTokens': '购买代币',
    'faucet.mainnetNotice': '这是主网网络。您需要从加密货币交易所购买 {token} 才能在此网络上使用。',
    'faucet.networkInfo': '网络详细信息',
    'faucet.viewExplorer': '在区块链浏览器查看',
    'faucet.option': '备用渠道 {num}',
    'faucet.chainId': '链 ID：',
    'faucet.nativeToken': '原生代币：',
    'faucet.explorer': '区块链浏览器：',
    'faucet.instantClaim': 'DApp 内即时水龙头',
    'faucet.instantClaimDesc': '直接将 50 HUC 测试代币领取至已连接的钱包，快速体验 DEX 功能',
    'faucet.claimButton': '免费领取 50 HUC',
    'faucet.claiming': '正在铸造测试代币...',
    'faucet.claimedSuccess': '成功将 50 HUC 测试代币领取至您的钱包！',
    'faucet.cooldown': '冷却中，每 24 小时可领取一次。',
    'network.mainnet': '主网',

    // Overview / Landing Page
    'hero.badge': '新一代 DeFi 去中心化交易平台',
    'hero.titleMain': 'HuanChain DEX',
    'hero.titleSub': '专业级多链交易协议',
    'hero.desc': '在 {network} 上体验去中心化金融的未来，尊享闪电般的交易速度、深厚的流动性池和安全的跨链桥接。',
    'hero.launchApp': '启动应用',
    'hero.connectWallet': '连接钱包',
    'hero.exploreLiquidity': '探索流动性池',
    'hero.audited': '经过审计的智能合约 • 毫秒级确认 • 超低 Gas 费',
    'stats.volume': '总交易量',
    'stats.users': '活跃交易者',
    'stats.tokens': '支持代币种类',
    'stats.liquidity': '总锁仓价值 (TVL)',
    'features.title': '为什么选择 HuanChain DEX？',
    'features.subtitle': '前沿 DeFi 创新技术与机构级安全防护体系',
    'features.f1Title': '闪电极速撮合',
    'features.f1Desc': '优化的智能合约带来毫秒级执行体验，享受极低滑点和低廉的手续费。',
    'features.f2Title': '深厚流动性池',
    'features.f2Desc': '为资金池提供做市以赚取丰厚回报，支持收益自动复利和无常损失减免机制。',
    'features.f3Title': '无缝跨链资产桥',
    'features.f3Desc': '基于经过全面审计的跨链底层设施，轻松在10+主流公链之间转移代币。',
    'features.f4Title': '银行级安全合规',
    'features.f4Desc': '第三方安全机构严格审计、多重签名和链上实时监控，全天候保障资产安全。',
    'features.f5Title': '专业链上数据分析',
    'features.f5Desc': '提供实时K线图表、核心技术指标和资产组合分析，助您运筹帷幄。',
    'features.f6Title': 'Yield Farming 收益挖矿',
    'features.f6Desc': '多样化质押挖矿策略，最大化提高闲置加密资产的年化收益率。',
    'features.b1_1': '亚秒级极速撮合',
    'features.b1_2': '99.9% 稳定运行',
    'features.b1_3': 'MEV 防夹保护',
    'features.b2_1': '高额年化收益 APR',
    'features.b2_2': '自动复利机制',
    'features.b2_3': '极高资金利用效率',
    'features.b3_1': '支持 10+ 主流公链',
    'features.b3_2': '超 5 亿美元跨链转账',
    'features.b3_3': '闪电极速到账',
    'features.b4_1': '多签金库机制保护',
    'features.b4_2': '顶级安全机构全面审计',
    'features.b4_3': '100% 非托管去中心化',
    'features.b5_1': '实时毫秒级链上数据',
    'features.b5_2': '高精度行情计算',
    'features.b5_3': '智能资产组合洞察',
    'features.b6_1': '收益自动滚仓复利',
    'features.b6_2': '低风险高回报策略',
    'features.b6_3': '灵活多样的激励方案',
    'contract.info': '合约详细信息',
    'contract.switchTo': '切换至 {network}',
    'contract.router': '路由合约 (Router)：',
    'contract.factory': '工厂合约 (Factory)：',
    'app.installMetaMask': '请安装 MetaMask 或其他 Web3 钱包以进行连接！',
    'steps.title': '几分钟内轻松上手',
    'steps.subtitle': '加入数万名信赖 HuanChain DEX 的全球加密交易者',
    'steps.s1Title': '连接您的 Web3 钱包',
    'steps.s1Desc': '支持 MetaMask 及20多种主流硬件与去中心化钱包，一键安全接入。',
    'steps.s2Title': '准备测试/交易代币',
    'steps.s2Desc': '通过水龙头免费领取测试币，或向钱包存入资产准备交易。',
    'steps.s3Title': '开启去中心化交易',
    'steps.s3Desc': '简单几步即可完成代币兑换、做市赚取手续费或跨链转账。',
    'trusted.title': '深受行业领先项目信赖',
    'cta.title': '准备好开启下一代 DeFi 体验了吗？',
    'cta.desc': '加入全球超过 150,000 名用户，选择 HuanChain DEX 开启安全高效的链上交易。',

    // Footer
    'footer.desc': 'HuanChain 上领先的去中心化交易所。在最高效的 DeFi 平台上交易、赚取收益并构建未来。',
    'footer.protocol': '协议',
    'footer.resources': '资源',
    'footer.ecosystem': '生态系统',
    'footer.legal': '法律条规',
    'footer.community': '全球社区',
    'footer.docs': '开发文档',
    'footer.bounty': '漏洞赏金计划',
    'footer.governance': '社区治理',
    'footer.forum': '论坛讨论',
    'footer.analytics': '链上分析',
    'footer.tokenLists': '代币清单',
    'footer.brandAssets': '品牌素材',
    'footer.careers': '加入我们',
    'footer.terms': '服务条款',
    'footer.privacy': '隐私政策',
    'footer.cookie': 'Cookie 政策',
    'footer.disclaimerTitle': '免责声明',
    'footer.disclaimer': 'HuanChain DEX 是去中心化开源协议。加密资产交易具有较高市场风险，交易前请务必自行调研（DYOR）。',
    'footer.securityNotice': '安全提示',
    'footer.securityDesc': '请务必仔细核对合约地址，切勿向任何人透露私钥。HuanChain 绝不会索要您的助记词。',
    'footer.allRightsReserved': '保留所有权利。',
    'footer.riskWarning': '使用需自担风险。此为实验性版本。'
  }
};
